import React from "react";
import styled from "@emotion/styled";
import {
  ShopOutlined,
  TeamOutlined,
  ContainerOutlined,
  MessageOutlined,
  FileTextOutlined,
  StarOutlined,
} from "@ant-design/icons";
import { getScoreBand } from "../../../utils/Service/colors";

const ROW_ICONS = [ShopOutlined, TeamOutlined, ContainerOutlined, MessageOutlined, FileTextOutlined, StarOutlined];

const SectionHeatmapTable = ({ sections, cards }) => {
  return (
    <TableWrap>
      <Grid columns={cards.length}>
        <HeaderCell first>Sections</HeaderCell>
        {cards.map((c) => (
          <HeaderCell key={c.id}>
            <CycleHeading>
              <Dot color={c.color} />
              {c.name}
            </CycleHeading>
            <CycleDate>{c.date}</CycleDate>
          </HeaderCell>
        ))}

        {sections.map((section, rowIndex) => {
          const Icon = ROW_ICONS[rowIndex % ROW_ICONS.length];
          return (
            <React.Fragment key={section}>
              <RowLabel>
                <Icon style={{ color: "#8A94A6" }} />
                <span>{section}</span>
              </RowLabel>
              {cards.map((c) => {
                const score = c.scores?.[section] ?? 0;
                const band = getScoreBand(score);
                return (
                  <Cell key={c.id} bg={band.bg} text={band.text}>
                    {score ? `${score}%` : "N/A"}
                  </Cell>
                );
              })}
            </React.Fragment>
          );
        })}
      </Grid>
    </TableWrap>
  );
};

const TableWrap = styled.div`
  border: 1px solid #eaecef;
  border-radius: 12px;
  overflow: hidden;
  overflow-x: auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 260px) repeat(${(props) => props.columns}, minmax(140px, 1fr));
  min-width: ${(props) => 260 + props.columns * 140}px;
`;

const HeaderCell = styled.div`
  background: #f8f9fb;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #eaecef;
  border-right: 1px solid #eaecef;
  display: flex;
  flex-direction: column;
  gap: 2px;
  ${(props) => props.first && "justify-content: center; font-weight: 700; color: #16325c; font-size: 0.9rem;"}
`;

const CycleHeading = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: #16325c;
  font-size: 0.88rem;
`;

const CycleDate = styled.span`
  font-size: 0.75rem;
  color: #8a94a6;
  margin-left: 16px;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.color};
  flex-shrink: 0;
`;

const RowLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #eaecef;
  border-right: 1px solid #eaecef;
  font-size: 0.85rem;
  color: #353e4c;
  background: #ffffff;
`;

const Cell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #eaecef;
  border-right: 1px solid #eaecef;
  background: ${(props) => props.bg};
  color: ${(props) => props.text};
  font-weight: 700;
  font-size: 0.88rem;
`;

export default SectionHeatmapTable;
